import { Action } from './action';
import { NotificationDuration, NotificationType } from 'acscp/store/notificationState';
import { FormattedMessage } from 'react-intl';

export class AddNotification extends Action {
    constructor(
        public cause: string,
        public message: string | FormattedMessage.MessageDescriptor,
        public notificationType: NotificationType,
        public duration: NotificationDuration = NotificationDuration.Short, // only applies to Info types
        public messageValues?: {[key: string]: string | number | boolean | Date}
    ) {
        super();
    }
}

export class DismissNotification extends Action {
    constructor(public cause: string) {
        super();
    }
}
